/** Commercial Rafiki access. Data permissions remain enforced by each operation. */
export const RAFIKI_TIERS = Object.freeze({ base: 50, advanced: 200 });
const record = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);
const validTier = (tier) => Object.prototype.hasOwnProperty.call(RAFIKI_TIERS, tier);
export function normalizeRafikiAccess(value) {
  if (!record(value) || value.version !== 1) return null;
  if (value.mode === 'disabled') return { version: 1, mode: 'disabled' };
  if (value.mode === 'all' && validTier(value.tier)) return { version: 1, mode: 'all', tier: value.tier };
  if (value.mode === 'selected' && record(value.users)
      && Object.entries(value.users).every(([uid, tier]) => uid.length > 0 && !uid.includes('/') && validTier(tier))) {
    return { version: 1, mode: 'selected', users: { ...value.users } };
  }
  return null;
}
export function resolveRafikiAccess(zoo, userId) {
  const raw = zoo?.rafikiAccess;
  // Existing parks retain their previous behaviour until staff explicitly configure Rafiki.
  if (raw == null) return { mode: 'legacy', allowed: true, limit: null, tier: null };
  const config = normalizeRafikiAccess(raw);
  if (!config) return { mode: 'invalid', allowed: false, limit: 0, tier: null };
  const tier = config.mode === 'all' ? config.tier
    : config.mode === 'selected' && Object.prototype.hasOwnProperty.call(config.users, userId) ? config.users[userId] : null;
  return { mode: config.mode, allowed: validTier(tier), limit: validTier(tier) ? RAFIKI_TIERS[tier] : 0, tier };
}
export const isRafikiFeature = (id) => id === 'logbook.assistant' || id === 'extensions.rafiki';
export const rafikiAutomationId = (kind, entityId) => `${kind}_${entityId}`;
